import PropTypes from 'prop-types';
import { FormGroup, Toggle } from '@celltrak/ui-components';
import noop from 'lodash/noop';

import { credentialForm } from '../../constants';

const IncludeBillingToggle = ({ isChecked, onChange }) => (
  <FormGroup>
    <div>
      <Toggle
        id={credentialForm.includeBillingId}
        size="sm"
        label={credentialForm.includeBillingLabel}
        checked={isChecked}
        onChange={onChange}
      />
    </div>
  </FormGroup>
);

IncludeBillingToggle.propTypes = {
  isChecked: PropTypes.bool,
  onChange: PropTypes.func,
};

IncludeBillingToggle.defaultProps = {
  isChecked: false,
  onChange: noop,
};

export default IncludeBillingToggle;
